// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__16i0v","head":"Table_head__3bbdi","col":"Table_col__2tYCX"};